<template>
  <div class="content home-page">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png" class="nav-icon-left"/>
        <div>{{ $t('Back') }}</div>
      </div>
    </div>
    <div class="info crfff">
      <div class="fs50 mt50 ac">{{ $t('History') }}</div>
      <div class="tab-wrap ac mt20">
        <div class="tab-item" :class="{active: type == 'pic'}" @click="switchTab('pic')">
          <img width="20" src="../../static/images/index/index_cate_aistudio.png"/>
          <span>{{ $t('ai_image') }}</span>
        </div>
        <div class="tab-item" :class="{active: type == 'doc'}" @click="switchTab('doc')">
          <img width="20" src="../../static/images/index/index_cate_aidoc.png"/>
          <span>{{ $t('ai_doc') }}</span>
        </div>
      </div>
      <div class="list mt30" v-for="(item,key,index) in list">
        <div class="fs26 mb20">{{ key }}</div>
        <div class="flex" style="flex-wrap: wrap;">
          <div :class="type == 'doc' ? 'doc-container' : 'img'" v-for="(item1,index) in item">
            <!-- 增加文档展示 logic -->
            <div class="doc-item flex ac" v-if="type == 'doc'" @click="goDetail(item1)">
              <div class="doc-icon">
                <img v-if="item1.type == 'ai_resume'" width="40"
                     src="../../static/images/index/index_ai_resume.png"/>
                <img v-else width="40" src="../../static/images/index/index_ai_ppt.png"/>
              </div>
              <div class="doc-info flex1 ml20">
                <div class="fs28 crfff text-ellipsis">{{ item1.description || 'No Description' }}</div>
                <div class="fs24 cr999 mt10" v-if="item1.status == 'success'">{{ item1.create_time }} ({{
                    item1.format
                  }})
                </div>
                <div class="fs24 cr999 mt10" v-else>{{ $t('process') }}...</div>
              </div>
              <div class="doc-ops ml20" v-if="item1.status == 'success'" @click.stop="goDetail(item1)">
                <img width="20" src="../../static/images/big.png"/>
              </div>
            </div>

            <!-- 原有的图片/视频逻辑 -->
            <div class="process" v-else-if="item1.status=='process'">{{ $t('process') }}</div>
            <div class="" v-else>
              <!--视频-->
              <div v-if="item1.format=='video'">
                <div class="his_type">
                  <img src="../../static/images/video_icon.png">
                </div>
                <img class="his-img" :src="item1.original_image_path || require('../../static/images/placeholder.png')"
                     loading="lazy"/>
                <div class="down ac" style="padding:5px 0">
                  <img width="18" style="border-radius: 0;" @click="getLink(item1.image_path,item1.format)"
                       src="../../static/images/big.png">
                </div>
              </div>
              <!--图片-->
              <div class="" v-else>
                <div class="his_type">
                  <img src="../../static/images/image_icon.png">
                </div>
                <img class="his-img" :src="item1.image_path || require('../../static/images/placeholder.png')"
                     loading="lazy"/>
                <div class="down ac" style="padding:5px 0">
                  <img width="18" style="border-radius: 0;" @click="getLink(item1.image_path,item1.format)"
                       src="../../static/images/big.png">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog ref="imgDialog" type="alert" title="" width="100" :modalFoot="false" :iscloseMask="true"
            style="min-height: 300px;">
      <div class="alert-modal" slot="mdBox">
        <div class="close" @click="closeTmgDialog" style="text-align: right;margin: 0 auto;font-size: 50px;">×</div>
        <div class="image ac">
          <div class="" style="font-size:0.25rem;margin-bottom: 0.2rem;">{{ $t('downTips1') }}</div>

          <div v-if="format=='video'">
            <video style="max-width: 80%" :src="url" controls preload="metadata"></video>
          </div>
          <div v-else-if="type == 'doc'" class="doc-preview">
            <img width="100" src="../../static/images/index/index_cate_aidoc.png"/>
            <div class="mt20 fs32 crfff">{{ format.toUpperCase() }} File</div>
          </div>
          <div class="" v-else>
            <img :src="url" style="max-width: 80%"/>
          </div>

          <div class="img-tools">
            <div class="ac mt20">
              <div class="input-item mt50" style="margin-bottom: 20px;">
                <div class="input-item2">
                  <input class="input" v-model="url" disabled type="" placeholder="">
                </div>
              </div>
              <button class="button fw7" style="width: 100%;" v-if="url" @click="copy(url)" id="copycode"
                      :data-clipboard-text="url">{{ $t('copyLink') }}
                <img style="margin-left: 10px;" width="18" src="../../static/images/copy1.png"/>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import Header from '../components/Header'
import Clipboard from 'clipboard';
import Dialog from '../components/dialog'

export default {
  components: {
    Header,
    Dialog
  },
  data() {
    return {
      list: [],
      imageShow: false,
      url: '',
      format: "",
      type: 'pic',
    }
  },
  created() {
    this.getHome();
  },
  methods: {
    getLink(url, format) {
      this.url = url
      this.format = format
      this.$refs.imgDialog.showMaskFun();
      return;
      let link = document.createElement('a');

      this.$refs.imgDialog.showMaskFun();
      link.href = url;// 图片的 URL
      link.download = '';// 可选，可以设置文件名
      link.click();// 模拟点击下载
    },

    closeTmgDialog() {
      this.url = ""
      this.$refs.imgDialog.closeMask();
    },
    back() {
      this.$router.go(-1);
    },
    switchTab(type) {
      this.type = type;
      this.list = [];
      this.getHome();
    },
    goDetail(item) {
      if (item.status !== 'success') {
        this.$utils.alertText(this.$t('process'), 50);
        return;
      }
      if (item.type === 'ai_resume') {
        this.$router.push({
          path: '/ai_Resume_detail',
          query: {
            url: item.image_path,
            name: item.description
          }
        })
        return;
      }
      if (item.type === 'ai_ppt') {
        this.$router.push({
          path: '/aiPpt_detail',
          query: {
            url: item.image_path,
            description: item.description,
            format: item.format
          }
        })
      }
    },
    copy(item) {
      var clipboard = new Clipboard("#copycode");
      clipboard.on("success", (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'));
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        //console.log("该浏览器不支持自动复制");
        // 释放内存
        clipboard.destroy();
      });
    },
    getHome() {
      let that = this;
      that.$parent.loadModal(true);
      that.$api.post('/api/user/history', {type: that.type}, r => {
        that.$parent.returnCode(r, function () {
          that.list = r.data
          that.$parent.loadModal(false);
        });

      })

    },
  }
}
</script>
<style>
.process {
  min-height: 3rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #6678da66;

}

.his-img {
  width: 2rem !important;
  height: 3rem !important;
  object-fit: cover !important;
}

.down {
  border-radius: 0;
  background: rgb(30 20 67 / 74%)
}

.down img {
}

.img img {
  border-radius: 0;
}

.doc-container {
  width: 100%;
}

.tab-wrap {
  display: flex;
  justify-content: center;
  width: 90%;
  margin: 0.4rem auto 0.2rem;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.6rem;
  padding: 0.06rem;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.tab-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  padding: 0.22rem 0;
  border-radius: 0.55rem;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  -webkit-tap-highlight-color: transparent;
  outline: none;
  user-select: none;
}

.tab-item.active {
  background: #66da6e;
  box-shadow: 0 4px 10px rgba(102, 120, 218, 0.3);
}

.tab-item img {
  width: 0.35rem;
  height: auto;
  opacity: 0.6;
  filter: grayscale(100%) brightness(200%);
}

.tab-item.active img {
  opacity: 1;
  filter: none;
}

.tab-item span {
  font-size: 0.28rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.tab-item.active span {
  color: #fff;
  font-weight: 600;
}

.doc-item {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 0.2rem;
  padding: 0.3rem;
  width: 100%;
  margin-bottom: 0.2rem;
  cursor: pointer;
}

.doc-info {
  overflow: hidden;
}

.doc-ops {
  background: rgba(255, 255, 255, 0.2);
  padding: 0.2rem;
  border-radius: 50%;
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ml20 {
  margin-left: 0.2rem;
}

.mt10 {
  margin-top: 0.1rem;
}

.mb20 {
  margin-bottom: 0.2rem;
}

.cr999 {
  color: #999;
}

.flex1 {
  flex: 1;
}

.doc-preview {
  padding: 0.5rem 0;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/history.vue